import React from "react";
import { createPortal } from "react-dom";
import { styled } from "styled-components";

interface Props {
  onClose: () => void;
  onConfirm: () => void;
}

function MinAreaAlert({ onClose, onConfirm }: Props) {
  return createPortal(
    <Dimmer onClick={onClose} aria-modal role="dialog">
      <Dialog onClick={(e) => e.stopPropagation()}>
        <Body>
          <img src="/asset/images/warn/WarnWithGrayCircle.svg" alt="" />
          <Content>
            <Title>1,000평 미만 소규모 농지입니다</Title>
            <Desc>
              1,000평 미만 소규모 농지에서는 <br /> 트랙터 운영 효율이 낮을 수
              있습니다.
            </Desc>
          </Content>
          <Bottom>
            <CancleButton onClick={onClose}>취소</CancleButton>
            <ApplyButton
              onClick={() => {
                onConfirm();
                onClose();
              }}
            >
              트랙터/부속기 입력하기
            </ApplyButton>
          </Bottom>
        </Body>
      </Dialog>
    </Dimmer>,
    document.body
  );
}

export default MinAreaAlert;

const Dimmer = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const Dialog = styled.div`
  display: flex;
  width: 312px;
  padding: 24px 16px 16px 16px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  border-radius: 16px;
  background: #fff;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const Title = styled.div`
  align-self: stretch;
  color: var(--Alias-Color-Text-Dark-Text-Primary, #171e26);
  text-align: center;
  font-feature-settings:
    "liga" off,
    "clig" off;

  /* Mo/Body/L-16-Bold */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 24px */
`;

const Desc = styled.div`
  align-self: stretch;
  color: var(--Alias-Color-Text-Dark-Text-Disabled, rgba(23, 30, 38, 0.4));
  text-align: center;
  font-feature-settings:
    "liga" off,
    "clig" off;

  /* Mo/Body/S-14-Medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
`;

const Bottom = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const Button = styled.button`
  border: none;
  outline: none;
  cursor: pointer;

  display: flex;
  padding: 12px 24px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
`;

const CancleButton = styled(Button)`
  color: var(--Alias-Color-Text-Dark-Text-Disabled, rgba(23, 30, 38, 0.4));
  background: var(--Alias-Color-Text-White-BlueGray-100, #eff2f5);
`;

const ApplyButton = styled(Button)`
  flex: 1 0 0;
  background-color: #1e9b6b;
  color: #fff;
`;
